// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { CourseApiPublicEndpointsGetCoursesData, CourseApiPublicEndpointsGetCoursesResponses, CourseApiPublicEndpointsSignupToCourseData, CourseApiPublicEndpointsSignupToCourseResponses, SupportApiPublicEndpointsCreateSupportMessageData, SupportApiPublicEndpointsCreateSupportMessageResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Get Courses
 */
export const courseApiPublicEndpointsGetCourses = <ThrowOnError extends boolean = false>(options?: Options<CourseApiPublicEndpointsGetCoursesData, ThrowOnError>) => (options?.client ?? client).get<CourseApiPublicEndpointsGetCoursesResponses, unknown, ThrowOnError>({ url: '/gateway/api/public/courses/', ...options });

/**
 * Signup To Course
 */
export const courseApiPublicEndpointsSignupToCourse = <ThrowOnError extends boolean = false>(options: Options<CourseApiPublicEndpointsSignupToCourseData, ThrowOnError>) => (options.client ?? client).post<CourseApiPublicEndpointsSignupToCourseResponses, unknown, ThrowOnError>({
    url: '/gateway/api/public/courses/{course_id}/signup',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Support Message
 */
export const supportApiPublicEndpointsCreateSupportMessage = <ThrowOnError extends boolean = false>(options: Options<SupportApiPublicEndpointsCreateSupportMessageData, ThrowOnError>) => (options.client ?? client).post<SupportApiPublicEndpointsCreateSupportMessageResponses, unknown, ThrowOnError>({
    url: '/gateway/api/public/support/messages',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
